import React, { useEffect, useReducer, useState } from "react";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import '../../elements/FormStyle/FormStyle.css';
import './CourseEnroll.css';
import PayStackHook from "../../elements/PayStackHook/PayStackHook";

const CourseEnroll = () => {
    const { cid } = useParams();
    const [course, setCourse] = useState({});

    const configReducer = (state, item) => {
        return {
            ...state,
            [item.name]: item.value
        }
    }
    const [config, setConfig] = useReducer(configReducer, {
        reference: (new Date()).getTime().toString(),
        email: '',
        amount: 0,
        publicKey: 'pk_live_43093fcffe8b0dfeb2198f8a365e18103c039388'
    });

    const formInputReducer = (state, input) => {
        if (input.type === 'reset') {
            return {
                sfname: '',
                slname: '',
                sgender: 'Male',
                sphone: '',
                semail: '',
                password: '',
                scat: '',
                scost: 0,
                scourse: cid
            }
        }
        if (input.name === 'semail') {
            setConfig({
                name: 'email',
                value: input.value
            })
        }
        return {
            ...state,
            [input.name]: input.value
        }
    }

    const [formInputs, setFormInputs] = useReducer(formInputReducer, {
        sfname: '',
        slname: '',
        sgender: 'Male',
        sphone: '',
        semail: '',
        password: '',
        scat: '',
        scost: 0,
        scourse: cid
    })

    const handleCategoryChange = (input) => {

        const cost = input.value === 'Online'
            ? course.conline_cost
            : course.consite_cost;

        if (Number(cost) !== 0) {
            setFormInputs(input);
            setFormInputs({
                name: 'scost',
                value: cost
            });
            setConfig({
                name: 'amount',
                value: cost * 100
            });
        }
    }

    const fetchCourse = () => {
        axios.get('https://lerntutors.com/react_2026_api/courses/courses.php?cid=' + cid)
        .then(res => res.data)
        .then(data => {
            if (data) {
                setCourse(data);
                setTimeout(() => {
                    if (Number(data.conline_cost) !== 0) {
                        setFormInputs({
                            name: 'scat',
                            value: 'Online'
                        });
                        setFormInputs({
                            name: 'scost',
                            value: data.conline_cost
                        });
                        setConfig({
                            name: 'amount',
                            value: data.conline_cost * 100
                        });
                    }
                    else {
                        setFormInputs({
                            name: 'scat',
                            value: 'On-site'
                        });
                        setFormInputs({
                            name: 'scost',
                            value: data.consite_cost
                        });
                        setConfig({
                            name: 'amount',
                            value: data.consite_cost * 100
                        });
                    }
                }, 1000);
            }
            else {
                setCourse({});
            }
        });
    }

    useEffect(() => {
        let mounted = true;
        if (mounted) {
            fetchCourse();
            document.body.scrollTop = 0;
            document.documentElement.scrollTop = 0;
        }
        return () => mounted = false;
    }, [])

    const handleEnroll = () => {
        axios.post('https://lerntutors.com/react_2026_api/students/signup.php', formInputs)
        .then(res => res.data)
        .then(data => {
            if (data.status === 'success') {
                alert(data.message);
                setFormInputs({
                    type: 'reset'
                });
                fetchCourse();
            }
            else {
                alert(data.message);
            }
        })
        .catch(err => {
            console.error('Error enrolling student:', err);
            alert('Enrollment failed. Please contact support for verification and next steps.');
        });
    }

    return (
        <div className="lern-courseenroll">
            <div className="form-div">
                <form>
                    <fieldset>
                        <legend>Enroll for {course.cname}</legend>
                        <p className="alert alert-danger text-center">(Provide all details to proceed)</p>
                        <div className="form-group">
                            <input type="text" name="sfname" placeholder="First Name" onChange={(e) => setFormInputs(e.target)} value={formInputs.sfname} required />
                        </div>
                        <div className="form-group">
                            <input type="text" name="slname" placeholder="Last Name (Surname)" onChange={(e) => setFormInputs(e.target)} value={formInputs.slname} required />
                        </div>
                        <div className="form-group">
                            <select name="sgender" onChange={(e) => setFormInputs(e.target)} value={formInputs.sgender} required>
                                <option value="Male">Male</option>
                                <option value="Female">Female</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <input type="text" name="sphone" placeholder="Phone Number" onChange={(e) => setFormInputs(e.target)} value={formInputs.sphone} required />
                        </div>
                        <div className="form-group">
                            <input type="email" name="semail" placeholder="Email Address" onChange={(e) => setFormInputs(e.target)} value={formInputs.semail} required />
                        </div>
                        <div className="form-group">
                            <input type="password" name="password" placeholder="Password" onChange={(e) => setFormInputs(e.target)} value={formInputs.password} required />
                        </div>
                        <div className="form-group">
                            <select name="scat" onChange={(e) => handleCategoryChange(e.target)} value={formInputs.scat} required>
                                <option value="Online">Online</option>
                                <option value="On-site">On-site</option>
                            </select>
                        </div>
                        <div className="form-group">
                            <input type="number" name="scost" placeholder="Course Cost" onChange={(e) => setFormInputs(e.target)} value={formInputs.scost} readOnly={true} required />
                        </div>
                        <div className="form-group btn-div">
                            {formInputs.sfname && 
                            formInputs.slname && 
                            formInputs.sgender &&
                            formInputs.sphone &&
                            formInputs.semail &&
                            formInputs.password &&
                            formInputs.scat &&
                            formInputs.scost &&
                            <PayStackHook config={config} handleEnroll={handleEnroll} />}
                        </div>
                    </fieldset>
                </form>
            </div>
            <div className="back-btn">
                <Link to={`/courses/${cid}`}>Back to Course</Link>
            </div>
        </div>
    )
}

export default CourseEnroll;